export const CONSTANTS = {
  SCREEN_GROUP: 'customer',
  REQUEST_DETAIL: 'request-customer-detail',
  LIST_ALL: 'list-customer-all',
  LIST_CUSTOMER_DICT: 'list-customer-dict',
  LIST_CUSTOMER_ITEM_UOM: 'list-customer-item-uom',
  GRID_CUSTOMER_LOOKUP_DIALOG: 'grid-customer-lookup-dialog',
} as const;
